exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-conditions[data-v-19a0a4da]{width:1800px;height:280px;padding:20px;background:#f2f3f5}.select-conditions-row[data-v-19a0a4da]{width:1000px;margin:20px 0}.clear-all[data-v-19a0a4da]{margin-left:40px;font-size:14px}.platform-table[data-v-19a0a4da]{margin-top:20px}\n", ""]);

// exports
